import { createSlice } from '@reduxjs/toolkit';
import { brandGetLandingPage2 } from './brandAsyncThunk';

const brandGetLandingPageSlice2 = createSlice({
  name: "brand",
  initialState: {
    payload: {},
    isLoading: false,
    isSuccess: false,
    isFail: false,
  },
  reducers: {},
  extraReducers: {
    [brandGetLandingPage2.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isFail = false;
    },
    [brandGetLandingPage2.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.payload = { ...action.payload.list };
    },
    [brandGetLandingPage2.rejected]: (state, action) => {
      state.isLoading = false;
      state.isFail = true;
    },
  },
});

export default brandGetLandingPageSlice2.reducer;